import FormikSelect from './formik-select';

export default FormikSelect;
